import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Stacked from '../../shared/Stacked/stacked.vue';
import StackedOverflow from '../../shared/StackedOverflow/stacked.overflow.vue';
import EpicNavbar from '../../RifoDesign/EpicNavbar/epic.navbar.vue';
import { CommonConfig } from '../../configs/config.common';
import EpicSearchBar from '../../RifoDesign/EpicSearchBar/epic.search.bar.vue';
import EpicBody from '../../RifoDesign/EpicBody/epic.body.vue';
import EpicCarousel from '../../RifoDesign/EpicCarousel/epic.carousel.vue';
import EpicMobileHeader from '../../RifoDesign/EpicMobileHeader/epic.mobile.header.vue';
@Component({
    components: {
        Stacked,
        EpicNavbar,
        EpicSearchBar,
        EpicBody,
        EpicCarousel,
        StackedOverflow,
        EpicMobileHeader
    }
})
export default class EpicHeader extends Vue {
    public title: string = 'EpicHeader';

    public configs = new CommonConfig();

    public maxHeight = '450px';

    public bannerMaskStyle = {
    };

    public showCondition: boolean = false;
    public youtube = false;
    public rightDock = false;
    public mobileBannerUri = `${this.configs.rifoDesignAssetsUrl}/epic-header/bg0.jpg`;
    @Watch('$route.fullPath', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
        this.showCondition = this.$route.fullPath === '/';
    }

    public bannerStyles: any[] = [
    ];

    public navExpend() {
        this.rightDock = true;
    }
    public navClose() {
        this.rightDock = false;
    }
    public created() {
        this.bannerStyles = [];
        this.bannerMaskStyle = {
            'height': this.maxHeight,
            'width': '100%',
            'background-image': `linear-gradient(
                to bottom,
                rgba(0, 0, 0, 1.0),
                rgba(0, 0, 0, 0.5),
                rgba(0, 0, 0, 0)
            )`,
        };
        for (let i = 0; i < 8; i++) {
            this.bannerStyles.push(
                {
                    'height': this.maxHeight,
                    'width': '100%',
                    'background-image': `url('${this.configs.rifoDesignAssetsUrl}/epic-header/bg${i}.jpg')`,
                    'background-size': 'cover',
                    'background-position': 'center',
                    'background-repeat': 'no-repeat',
                    'overflow': 'hidden',
                }
            );
        }
    }

    public getRifoDesignAssets(str: string = '') {
        return `${this.configs.rifoDesignAssetsUrl}${str}`;
    }

    public youtubeOpen() {
        setTimeout(() => { this.youtube = true; }, 100);
    }

    public youtubeOutside() {
        // console.log('outside');
        if (this.youtube) {
            this.youtube = false;
        }
    }
}
